export default __webpack_public_path__ + "static/media/ic_avatar.48b2764b.svg";